// Lumière minimal theme JS
document.addEventListener('click', (e) => {
  const t = e.target.closest('[data-menu-toggle]');
  if (t) {
    const m = document.getElementById('mobile-nav');
    if (m) m.classList.toggle('open');
  }
});

// Product gallery thumbnail switching
document.querySelectorAll('[data-gallery]').forEach(g => {
  const main = g.querySelector('.main img');
  g.querySelectorAll('.thumb').forEach(t => {
    t.addEventListener('click', () => {
      g.querySelectorAll('.thumb').forEach(x => x.classList.remove('active'));
      t.classList.add('active');
      const src = t.querySelector('img')?.dataset.full || t.querySelector('img')?.src;
      if (main && src) main.src = src;
    });
  });
});

// Quantity inputs
document.querySelectorAll('[data-qty]').forEach(box => {
  const input = box.querySelector('input');
  box.querySelector('[data-qty-dec]')?.addEventListener('click', () => {
    input.value = Math.max(1, parseInt(input.value || '1', 10) - 1);
  });
  box.querySelector('[data-qty-inc]')?.addEventListener('click', () => {
    input.value = parseInt(input.value || '1', 10) + 1;
  });
});
